export default __webpack_public_path__ + "static/media/gallery - original vs translated_02.fd79e399.jpg";